module.exports = __webpack_public_path__ + "img/maze.f0c30402.jpg";